import { useWidget } from '../../../../../providers/widget'
import { useFetchWidget } from '../../../../../hooks'
import { ExploreWidgetConfig } from '../../../config'
import { useExplorer } from '../../../providers'
import { writePartyParams } from '../../../../../common/occupancy'
import { resolvePropertyLink, withStayParams } from '../../../../../common/property-href'
import { usePropertyHrefFeed } from '../../../../../common/use-property-href-feed'

/**
 * Navigate to a property page from a find-by-name match, carrying the current
 * dates/party so the PDP opens on the same stay the visitor was searching.
 *
 * Shared by the Where field's inline property section and the WHAT popover's
 * "By name" tab (#870 slice 5) — both resolve the same match rows from
 * `useNameFinder`, so they must resolve the same destination URL.
 */
export function usePropertyNavigate(): (slug: string) => void {
  const { options, feedId, widgetId } = useWidget<ExploreWidgetConfig>()
  const { state } = useExplorer()
  const { data: widgetData } = useFetchWidget(feedId, widgetId)
  const pdpRoute = widgetData?.feed?.additional_info?.reverseProxy?.routes?.pdp || '/property/[slug]'
  const hrefFeed = usePropertyHrefFeed(widgetData?.feed)

  return (slug: string) => {
    const params = new URLSearchParams()
    const vf = state.visitorFilters
    if (vf.checkin && vf.checkout) {
      params.set('checkin', vf.checkin)
      params.set('checkout', vf.checkout)
    }
    writePartyParams(params, {
      adults: vf.adults,
      children: vf.children,
      pets: options.showPetsFilter === false ? undefined : vf.pets,
    })
    // #1714: a property the feed maps to its own page (External Property Pages) opens there.
    const link = resolvePropertyLink({ feed: hrefFeed, slug, pdpRoute })
    if (typeof window !== 'undefined') window.location.href = withStayParams(link, params.toString())
  }
}
